/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportResultLogEntryRepresentation
 */
export interface ReportResultLogEntryRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ReportResultLogEntryRepresentation
     */
    time: string;
    /**
     * 
     * @type {string}
     * @memberof ReportResultLogEntryRepresentation
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ReportResultLogEntryRepresentation
     */
    message: string;
}

/**
 * Check if a given object implements the ReportResultLogEntryRepresentation interface.
 */
export function instanceOfReportResultLogEntryRepresentation(value: object): value is ReportResultLogEntryRepresentation {
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ReportResultLogEntryRepresentationFromJSON(json: any): ReportResultLogEntryRepresentation {
    return ReportResultLogEntryRepresentationFromJSONTyped(json, false);
}

export function ReportResultLogEntryRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportResultLogEntryRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'time': json['time'],
        'type': json['type'],
        'message': json['message'],
    };
}

export function ReportResultLogEntryRepresentationToJSON(json: any): ReportResultLogEntryRepresentation {
    return ReportResultLogEntryRepresentationToJSONTyped(json, false);
}

export function ReportResultLogEntryRepresentationToJSONTyped(value?: ReportResultLogEntryRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'time': value['time'],
        'type': value['type'],
        'message': value['message'],
    };
}

